import BenefitCard from './BenefitCard';
import { BenefitsFragmentFragment } from '../../__generated__/graphql';
import { Heading3 } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './benefits.module.css';

const Benefits: ContentBlock<BenefitsFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.benefits;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.benefitsSectionContainer}
    >
      <div className={style.benefits}>
        <Heading3
          className={style.benefitsTitle}
          fontSize={20}
        >
          {contentBlockProps.sectionDescription}
        </Heading3>

        {contentBlockProps.benefitCards?.map(benefit => {
          if (benefit) {
            return (
              <BenefitCard
                buttonId={benefit.buttonId ?? ''}
                buttonLinkFragment={benefit.button}
                className={style.benefitCard}
                description={benefit.description ?? ''}
                image={benefit.cardImage}
                key={benefit.title ?? ''}
                title={benefit.title ?? ''}
              />
            );
          }
        })}
      </div>
    </Section>
  );
};

export default Benefits;
